import React, { useState, useEffect } from "react";
import { IoClose, IoChevronBack, IoChevronForward } from "react-icons/io5";

const ImageCarousel = ({ images, initialIndex = 0, onClose, projectTitle }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    const handleArrowKeys = (e) => {
      if (e.key === "ArrowLeft") {
        goToPrevious();
      } else if (e.key === "ArrowRight") {
        goToNext();
      }
    };

    window.addEventListener("keydown", handleEscape);
    window.addEventListener("keydown", handleArrowKeys);

    // Prevent scrolling on body when modal is open
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleEscape);
      window.removeEventListener("keydown", handleArrowKeys);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!images || images.length === 0) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black bg-opacity-90 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
        aria-label="Close carousel"
      >
        <IoClose size={32} />
      </button>

      {/* Project Title */}
      {projectTitle && (
        <div className="absolute top-4 left-4 text-white text-lg sm:text-xl font-semibold z-10">
          {projectTitle}
        </div>
      )}

      {/* Previous Button */}
      {images.length > 1 && (
        <button
          onClick={goToPrevious}
          className="absolute left-2 sm:left-4 text-white hover:text-gray-300 transition-colors bg-black bg-opacity-50 rounded-full p-2 sm:p-3"
          aria-label="Previous image"
        >
          <IoChevronBack size={24} className="sm:w-8 sm:h-8" />
        </button>
      )}

      {/* Image Container */}
      <div className="max-w-6xl max-h-[80vh] flex items-center justify-center">
        <img
          src={images[currentIndex]}
          alt={`${projectTitle} - Image ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-lg"
        />
      </div>

      {/* Next Button */}
      {images.length > 1 && (
        <button
          onClick={goToNext}
          className="absolute right-2 sm:right-4 text-white hover:text-gray-300 transition-colors bg-black bg-opacity-50 rounded-full p-2 sm:p-3"
          aria-label="Next image"
        >
          <IoChevronForward size={24} className="sm:w-8 sm:h-8" />
        </button>
      )}

      {/* Image Counter */}
      {images.length > 1 && (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white bg-black bg-opacity-50 px-4 py-2 rounded-full text-sm sm:text-base">
          {currentIndex + 1} / {images.length}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
